/**
 * The describo profiles in this directory are copied from 
 * https://github.com/Language-Research-Technology/language-data-commons-vocabs/blob/master/profiles
 */


import schema from './schema.json'
import language from './text-commons-collection-profile.json'

export const profiles = [schema, language];